import LotCard from "./LotCard";

export default function LotsList({ lots, lotsLoading }) {
  return (
    <div className="card" style={{ marginBottom: 14 }}>
      <div className="card-header">
        <span className="card-title">📦 Lots sous douane ({lots.length})</span>
      </div>
      {lotsLoading ? (
        <div style={{ padding: 20, textAlign: "center", color: "var(--muted)" }}>
          Chargement...
        </div>
      ) : lots.length === 0 ? (
        <div style={{ padding: 20, textAlign: "center", color: "var(--muted)" }}>
          Aucun lot sous douane
        </div>
      ) : (
        <div style={{ padding: 0 }}>
          {lots.map((lot, index) => (
            <LotCard
              key={lot.id}
              lot={lot}
              index={index}
              totalLots={lots.length}
            />
          ))}
        </div>
      )}
    </div>
  );
}
